import { DEFAULT_SORTER } from '../utils/DataConstants';
import {
	supplierFacilitiesRestCrudThunksForBuyer,
	supplierFacilitiesRestCrudThunksForSupplier,
} from './supplier_facilities_thunks';
import { nullSafeGet, nullSafeGetOrElse } from '../utils/DataAccessUtils';
import { PAGE_SIZE_OPTIONS } from '../components/WorkOrderTable/config/pagination/pagination';
const queryString = require('qs');
const defaultPagination = { current: 1, pageSize: 10 };
const defaultSearchPagination = {
	current: 1,
	pageSize: 10,
	pageSizeOptions: PAGE_SIZE_OPTIONS,
	showSizeChanger: true,
};

const REST_CRUD_THUNKS_NAMES = {
	supplier_facilities: {
		supplier: supplierFacilitiesRestCrudThunksForSupplier,
		buyer: supplierFacilitiesRestCrudThunksForBuyer,
		public: null,
	},
};

export const getMethod = (stateName) => (userType) =>
	nullSafeGet(`${stateName}.${userType}`, REST_CRUD_THUNKS_NAMES);

export const parseURL = (
	handleQueryParams,
	history,
	location,
	preAppliedFilters,
	initialPagination,
	initialSorting,
	initialFilters = {}
) => {
	let pagination = initialPagination || defaultPagination;
	let sorting = initialSorting || DEFAULT_SORTER;
	let filters = { ...preAppliedFilters, ...initialFilters };
	if (handleQueryParams && location) {
		let searchString = location.search;
		if (searchString[0] === '?') {
			searchString = searchString.slice(1);
		}
		const queryParams = queryString.parse(searchString);

		const {
			current = pagination.current,
			pageSize = pagination.pageSize,
			sort_by = sorting.sort_by,
			order = sorting.order,
			...workOrderFilters
		} = queryParams;

		pagination = { current: parseInt(current), pageSize: parseInt(pageSize) };
		sorting = { sort_by, order };
		filters = {
			...(workOrderFilters || {}),
			...preAppliedFilters,
		};
		history.replace(`${window.location.pathname}?${queryString.stringify(queryParams)}`);
	}
	return { pagination, sorting, filters };
};

export const fetchRecords =
	(stateName, fetchData = defaultFetchData) =>
	(userType) =>
	(
		handleQueryParams,
		history,
		location,
		targetCollectionName,
		preAppliedFilters = {},
		initialPagination,
		initialSorting,
		initialFilters
	) =>
	(dispatch, getState) => {
		const { pagination, sorting, filters } = parseURL(
			handleQueryParams,
			history,
			location,
			preAppliedFilters,
			initialPagination,
			initialSorting,
			initialFilters
		);
		dispatch(
			fetchData(stateName)(userType)(
				handleQueryParams,
				history,
				{},
				targetCollectionName,
				pagination,
				sorting,
				filters
			)
		);
	};

export const updatePagination =
	(stateName, fetchData) =>
	(userType) =>
	(handleQueryParams, history, targetCollectionName, pagination, ignoreRefreshCounts) =>
	(dispatch, getState) => {
		const { sorting, filters } = getState()[stateName][targetCollectionName];
		dispatch(
			fetchData(stateName)(userType)(
				handleQueryParams,
				history,
				null,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				ignoreRefreshCounts
			)
		);
	};

export const updateFilters =
	(stateName, fetchData = defaultFetchData) =>
	(userType) =>
	(handleQueryParams, history, targetCollectionName, filters, ignoreRefreshCounts) =>
	(dispatch, getState) => {
		const {
			sorting,
			filters: storeFilters,
			pagination,
		} = getState().getState()[stateName][targetCollectionName];
		dispatch(
			fetchData(stateName)(userType)(
				handleQueryParams,
				history,
				null,
				targetCollectionName,
				{ ...pagination, current: 1 },
				sorting,
				{
					...storeFilters,
					...filters,
				}
			)
		);
	};
export const replaceFiltersAndSorting =
	(stateName, fetchData = defaultFetchData) =>
	(userType) =>
	(handleQueryParams, history, targetCollectionName, filters, sorting, ignoreRefreshCounts) =>
	(dispatch, getState) => {
		const { pagination } = getState()[stateName][targetCollectionName];
		dispatch(
			fetchData(stateName)(userType)(
				handleQueryParams,
				history,
				null,
				targetCollectionName,
				{ ...pagination, current: 1 },
				sorting,
				filters
			)
		);
	};
export const clearFilters =
	(stateName, fetchData = defaultFetchData) =>
	(userType) =>
	(handleQueryParams, history, targetCollectionName, preAppliedFilters, ignoreRefreshCounts) =>
	(dispatch, getState) => {
		const { pagination } = getState()[stateName][targetCollectionName];
		dispatch(
			fetchData(stateName)(userType)(
				handleQueryParams,
				history,
				null,
				targetCollectionName,
				{ ...pagination, current: 1 },
				{ ...DEFAULT_SORTER },
				{
					...preAppliedFilters,
				}
			)
		);
	};
export const updateSorting =
	(stateName, fetchData = defaultFetchData) =>
	(userType) =>
	(handleQueryParams, history, targetCollectionName, sorting, ignoreRefreshCounts) =>
	(dispatch, getState) => {
		const { filters, pagination } = getState()[stateName][targetCollectionName];
		dispatch(
			fetchData(stateName)(userType)(
				handleQueryParams,
				history,
				null,
				targetCollectionName,
				{ ...pagination, current: 1 },
				sorting,
				filters
			)
		);
	};

export const defaultFetchData =
	(stateName) =>
	(userType) =>
	(
		handleQueryParams,
		history,
		additionalParams,
		targetCollectionName,
		pagination,
		sorting,
		filters
	) =>
	(dispatch) => {
		dispatch(
			getMethod(stateName)(userType).read(
				additionalParams,
				targetCollectionName,
				pagination,
				sorting,
				filters
			)
		);
		if (handleQueryParams) {
			const queryParams = queryString.stringify({
				...{
					current: pagination.current,
					pageSize: pagination.pageSize,
				},
				...sorting,
				...filters,
				...additionalParams,
			});
			history.replace(`${window.location.pathname}?${queryParams}`);
		}
	};

export const fetchOne =
	(stateName) =>
	(userType) =>
	(params, targetCollectionName, pagination, sorting, filters, addToTargetCollection) =>
	(dispatch) =>
		dispatch(
			getMethod(stateName)(userType).read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		);

export const fetchMultiple =
	(stateName) => (userType) => (ids, targetCollectionName) => (dispatch) =>
		dispatch(getMethod(stateName)(userType).readMultiple(ids, targetCollectionName));
